import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import useIntersectionObserver from '@magento/peregrine/lib/hooks/useIntersectionObserver';
export var useIsInViewport = function useIsInViewport(props) {
  var elementRef = props.elementRef,
      _props$renderOnce = props.renderOnce,
      renderOnce = _props$renderOnce === void 0 ? true : _props$renderOnce;
  var intersectionObserver = useIntersectionObserver();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInViewport = _useState2[0],
      setIsInViewport = _useState2[1];

  useEffect(function () {
    if (!elementRef || !elementRef.current || !intersectionObserver) {
      setIsInViewport(true);
      return null;
    } // Prevent init if already rendered once


    if (isInViewport && renderOnce) {
      return null;
    }

    var htmlElement = elementRef.current;
    var elementObserver = new IntersectionObserver(function (entries, observer) {
      var isIntersecting = entries.some(function (entry) {
        return entry.isIntersecting;
      }) === true;
      setIsInViewport(isIntersecting); // Stop observing if already rendered once

      if (isIntersecting && renderOnce) {
        observer.unobserve(htmlElement);
      }
    });
    elementObserver.observe(htmlElement);
    return function () {
      elementObserver.unobserve(htmlElement);
    };
  }, [elementRef, intersectionObserver, isInViewport, renderOnce]);
  return isInViewport;
};